/**
 * AdditiveFunction - synchronized with the Prisma enum of the same name.
 *
 * The 24 functional categories of Annex VII Part C, Regulation (EU)
 * 1169/2011, in the order the regulation itself lists them. An additive on a
 * label must show its functional category plus its name or E-number
 * (art. 20 lett. a): `IngredientComponent.additiveFunction` and
 * `Ingredient.additiveFunction` both use this union.
 *
 * Reconciled with `schema.prisma` at the close of Wave 0. The first draft of
 * this file dropped `ACID` and carried a `PACKAGING_GAS` that belongs to the
 * functional classes of Reg. (EC) 1333/2008, not to Annex VII Part C, and
 * spelled `STABILIZER` where the regulation's English text reads
 * "Stabiliser". The Prisma enum was correct on all three counts and is the
 * reference; any future divergence is resolved against the regulation text.
 */
export const ADDITIVE_FUNCTIONS = [
  'ACID',
  'ACIDITY_REGULATOR',
  'ANTICAKING_AGENT',
  'ANTIFOAMING_AGENT',
  'ANTIOXIDANT',
  'BULKING_AGENT',
  'COLOUR',
  'EMULSIFIER',
  'EMULSIFYING_SALT',
  'FIRMING_AGENT',
  'FLAVOUR_ENHANCER',
  'FLOUR_TREATMENT_AGENT',
  'FOAMING_AGENT',
  'GELLING_AGENT',
  'GLAZING_AGENT',
  'HUMECTANT',
  'MODIFIED_STARCH',
  'PRESERVATIVE',
  'PROPELLANT_GAS',
  'RAISING_AGENT',
  'SEQUESTRANT',
  'STABILISER',
  'SWEETENER',
  'THICKENER',
] as const;
export type AdditiveFunction = (typeof ADDITIVE_FUNCTIONS)[number];
